// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  font-family: "Montserrat", sans-serif !important;
}

body {
  -webkit-font-smoothing: antialiased;
}

hr {
  height: 1px;
  background: #444343;
  border: none;
}

.dob-label {
  margin-top: 20px;
}

.top-label {
  color: #19608f;
  font-size: 1.2rem;
  font-weight: 600;
  padding: none;
}

.top-label-secondary-text {
  color: #19608f;
  margin-bottom: 15px;
  font-weight: 500;
}

.disabledColor {
  background: rgb(227, 227, 227);
  opacity: 0.6;
  color: black;
  font-weight: 600;
}

.gutter-80 {
  max-width: 1800px;
  padding: 20px 9px;
  margin: 0 auto;
  width: 80%;
}

.gutter-90 {
  max-width: 1800px;
  padding: 20px 9px;
  margin: 0 auto;
  width: 90%;
}

.gutter-96 {
  max-width: 1800px;
  padding: 20px 9px;
  margin: 0 auto;
  width: 96%;
}

.grade-gutter-90 {
  max-width: 1800px;
  margin: 0 auto;
  width: 90%;
}
.grade-gutter-90 .will-be {
  text-decoration: underline;
}
.grade-gutter-90 .bold {
  font-weight: 650;
}
.grade-gutter-90 .yellow-box {
  border-radius: 4px;
  background: #FEBF31;
  padding: 3px 5px;
  font-weight: 600;
}

.out-of-bounds-container {
  display: flex;
  flex-direction: row;
  height: 500px;
  justify-content: center;
  width: 100%;
}
.out-of-bounds-container .out-of-bounds {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  align-items: center;
  background: #D1D3D4;
  border: 2px solid #A7A9AC;
  display: flex;
  flex-direction: column;
  height: 50%;
  padding: 50px;
  width: 80%;
}
.out-of-bounds-container hr {
  color: #444343;
  width: 90%;
}

@media only screen and (max-width: 1080px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
@media only screen and (max-width: 926px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
@media only screen and (max-width: 926px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
@media only screen and (max-width: 926px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
.entire-webpage {
  zoom: 2;
  -moz-transform: scale(2); /* Firefox Property */
  -moz-transform-origin: 0 0;
  -o-transform: scale(2); /* Opera Property */
  -o-transform-origin: 0 0;
  -webkit-transform: scale(2); /* Safari Property */
  -webkit-transform-origin: 0 0;
  transform: scale(2); /* Standard Property */
  transform-origin: 0 0; /* Standard Property */
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/global/Global.scss","webpack://./src/styles/global/GlobalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AARA;EACI,gDAAA;AAWJ;;AAPA;EACI,mCAAA;AAUJ;;AARA;EACI,WAAA;EACA,mBDkBK;ECjBL,YAAA;AAWJ;;AATA;EACI,gBAAA;AAYJ;;AAVA;EACI,cDZM;ECaN,iBAAA;EACA,gBAAA;EACA,aAAA;AAaJ;;AAXA;EACI,cDlBM;ECmBN,mBAAA;EACA,gBAAA;AAcJ;;AAZA;EACI,8BAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAeJ;;AAbA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAgBJ;;AAdA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAiBJ;;AAfA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAkBJ;;AAhBA;EACI,iBAAA;EACA,cAAA;EACA,UAAA;AAmBJ;AAlBI;EACI,0BAAA;AAoBR;AAlBI;EACI,gBAAA;AAoBR;AAlBI;EC5DA,kBD6D0B;EACtB,mBD1CI;EC2CJ,gBAAA;EACA,gBAAA;AAoBR;;AAjBA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAoBJ;AAnBI;ECzEA,mBD0E0B;ECrD1B,2CAAA;EDuDI,mBAAA;EACA,mBDvDA;ECwDA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AAqBR;AAnBI;EACI,cD3DC;EC4DD,UAAA;AAqBR;;AAlBA;EACI;IACI,iBAAA;IACA,gBAAA;EAqBN;AACF;AAlBA;EACI;IACI,iBAAA;IACA,gBAAA;EAoBN;AACF;AAjBA;EACI;IACI,iBAAA;IACA,gBAAA;EAmBN;AACF;AAhBA;EACI;IACI,iBAAA;IACA,gBAAA;EAkBN;AACF;AAfA;EACI,OAAA;EACA,wBAAA,EAAA,qBAAA;EACA,0BAAA;EACA,sBAAA,EAAA,mBAAA;EACA,wBAAA;EACA,2BAAA,EAAA,oBAAA;EACA,6BAAA;EACA,mBAAA,EAAA,sBAAA;EACA,qBAAA,EAAA,sBAAA;AAiBJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Guardian Dashboard colors\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n\n$error: #CE3525;\n$error-dk: #aa3333;\n$error-hover: #cf4635;\n$hover-white: #E0E0E0;\n$light-background: #EFEFEF;\n\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #4a8319;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$icon-blue: #4DD9FF;\n","@import \"../../styles/global/Colors\";\n@import \"../../styles/global/GlobalMixins\";\n* {\n    font-family: \"Montserrat\", sans-serif !important;\n}\n\n// This is used for \"bolding\" text in chrome\nbody {\n    -webkit-font-smoothing: antialiased;\n}\nhr {\n    height: 1px;\n    background: $grey4a;\n    border: none;\n}\n.dob-label{\n    margin-top: 20px;\n}\n.top-label {\n    color: $dk-blue;\n    font-size: 1.2rem;\n    font-weight: 600;\n    padding: none;\n}\n.top-label-secondary-text {\n    color: $dk-blue;\n    margin-bottom: 15px;\n    font-weight: 500;\n}\n.disabledColor {\n    background: rgb(227, 227, 227);\n    opacity: .6;\n    color: black;\n    font-weight: 600;\n}\n.gutter-80 {\n    max-width: 1800px;\n    padding: 20px 9px;\n    margin: 0 auto;\n    width: 80%;\n}\n.gutter-90 {\n    max-width: 1800px;\n    padding: 20px 9px;\n    margin: 0 auto;\n    width: 90%;\n}\n.gutter-96 {\n    max-width: 1800px;\n    padding: 20px 9px;\n    margin: 0 auto;\n    width: 96%;\n}\n.grade-gutter-90 {\n    max-width: 1800px;\n    margin: 0 auto;\n    width: 90%;\n    .will-be {\n        text-decoration: underline;\n    }\n    .bold {\n        font-weight: 650;\n    }\n    .yellow-box {\n        @include borderRadius(4px);\n        background: $important;\n        padding: 3px 5px;\n        font-weight: 600;\n    }\n}\n.out-of-bounds-container {\n    display: flex;\n    flex-direction: row;\n    height: 500px;\n    justify-content: center;\n    width: 100%;\n    .out-of-bounds {\n        @include borderRadius(10px);\n        @include shadow();\n        align-items: center;\n        background: $grey1;\n        border: 2px solid $grey2;\n        display: flex;\n        flex-direction: column;\n        height: 50%;\n        padding: 50px;\n        width: 80%;\n    }\n    hr {\n        color: $grey4a;\n        width: 90%;\n    }\n}\n@media only screen and (max-width: 1080px) {\n    .action-button-reason {\n        font-size: 0.7rem;\n        padding: 0px 8px;\n    }\n}\n// iphone 13 pro 428x926\n@media only screen and (max-width: 926px) {\n    .action-button-reason {\n        font-size: 0.7rem;\n        padding: 0px 8px;\n    }\n}\n// galaxy note 412x883\n@media only screen and (max-width: 926px) {\n    .action-button-reason {\n        font-size: 0.7rem;\n        padding: 0px 8px;\n    }\n}\n// iPad 810x1080\n@media only screen and (max-width: 926px) {\n    .action-button-reason {\n        font-size: 0.7rem;\n        padding: 0px 8px;\n    }\n}\n\n.entire-webpage{\n    zoom: 2;\n    -moz-transform: scale(2);/* Firefox Property */\n    -moz-transform-origin: 0 0;\n    -o-transform: scale(2);/* Opera Property */\n    -o-transform-origin: 0 0;\n    -webkit-transform: scale(2);/* Safari Property */\n    -webkit-transform-origin: 0 0;\n    transform: scale(2); /* Standard Property */\n    transform-origin: 0 0;  /* Standard Property */\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowCustom($hor: 1px, $vert: 1px, $blur: 2px, $color: $shadow) {\n    box-shadow: $hor $vert $blur $color;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
